{
  "assets": [
    {
      "id": "5",
      "layers": [
        {
          "ind": 4,
          "ty": 4,
          "td": 1,
          "parent": 2,
          "ks": {},
          "ip": 0,
          "op": 685,
          "st": 0,
          "shapes": [
            {
              "ty": "rc",
              "p": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [100, 100],
                    "i": { "x": [0.009, 1], "y": [0.983, 1] },
                    "o": { "x": [0.508, 0], "y": [0, 0] }
                  },
                  {
                    "t": 46.8,
                    "s": [54.01, 100],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 61.8,
                    "s": [133.198, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 106.8,
                    "s": [120, 100],
                    "i": { "x": [0, 1], "y": [1, 1] },
                    "o": { "x": [0.5, 0], "y": [0, 0] }
                  },
                  {
                    "t": 154.8,
                    "s": [54, 100],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 169.8,
                    "s": [133.2, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 214.8,
                    "s": [120, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 232.8,
                    "s": [133.2, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 268.8,
                    "s": [47.4, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 304.8,
                    "s": [54, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 322.8,
                    "s": [27.8, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 358.8,
                    "s": [198.1, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 394.8,
                    "s": [185, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 412.8,
                    "s": [211.2, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 448.8,
                    "s": [40.9, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 484.8,
                    "s": [54, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 502.8,
                    "s": [14.8, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 538.8,
                    "s": [269.6, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 574.8,
                    "s": [250, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 585.72,
                    "s": [277.44, 100],
                    "i": { "x": [0.31, 1], "y": [1, 1] },
                    "o": { "x": [0.42, 0], "y": [0, 0] }
                  },
                  {
                    "t": 613.32,
                    "s": [40.28, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 634.8,
                    "s": [54, 100],
                    "i": { "x": [1, 0.65], "y": [1, 1] },
                    "o": { "x": [0, 0.35], "y": [0, 0] }
                  },
                  {
                    "t": 643.536,
                    "s": [54, 107],
                    "i": { "x": [1, 0.31], "y": [1, 1] },
                    "o": { "x": [0, 0.42], "y": [0, 0] }
                  },
                  {
                    "t": 665.616,
                    "s": [54, 46.5],
                    "i": { "x": [1, 0.4], "y": [1, 1] },
                    "o": { "x": [0, 0.25], "y": [0, 0] }
                  },
                  {
                    "t": 682.8,
                    "s": [54, 50],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  { "t": 684, "s": [54, 50], "h": 1 }
                ]
              },
              "r": { "a": 0, "k": 320 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [200, 200],
                    "i": { "x": [0.009, 1], "y": [0.983, 1] },
                    "o": { "x": [0.508, 0], "y": [0, 0] }
                  },
                  {
                    "t": 46.8,
                    "s": [108.02, 200],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 61.8,
                    "s": [266.396, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 106.8,
                    "s": [240, 200],
                    "i": { "x": [0, 1], "y": [1, 1] },
                    "o": { "x": [0.5, 0], "y": [0, 0] }
                  },
                  {
                    "t": 154.8,
                    "s": [108, 200],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 169.8,
                    "s": [266.4, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 214.8,
                    "s": [240, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 232.8,
                    "s": [266.4, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 268.8,
                    "s": [94.8, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 304.8,
                    "s": [108, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 322.8,
                    "s": [55.6, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 358.8,
                    "s": [396.2, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 394.8,
                    "s": [370, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 412.8,
                    "s": [422.4, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 448.8,
                    "s": [81.8, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 484.8,
                    "s": [108, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 502.8,
                    "s": [29.6, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 538.8,
                    "s": [539.2, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 574.8,
                    "s": [500, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 585.72,
                    "s": [554.88, 200],
                    "i": { "x": [0.31, 1], "y": [1, 1] },
                    "o": { "x": [0.42, 0], "y": [0, 0] }
                  },
                  {
                    "t": 613.32,
                    "s": [80.56, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 634.8,
                    "s": [108, 200],
                    "i": { "x": [1, 0.65], "y": [1, 1] },
                    "o": { "x": [0, 0.35], "y": [0, 0] }
                  },
                  {
                    "t": 643.536,
                    "s": [108, 214],
                    "i": { "x": [1, 0.31], "y": [1, 1] },
                    "o": { "x": [0, 0.42], "y": [0, 0] }
                  },
                  {
                    "t": 665.616,
                    "s": [108, 93],
                    "i": { "x": [1, 0.4], "y": [1, 1] },
                    "o": { "x": [0, 0.25], "y": [0, 0] }
                  },
                  {
                    "t": 682.8,
                    "s": [108, 100],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  { "t": 684, "s": [108, 100], "h": 1 }
                ]
              }
            },
            { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1] }, "o": { "a": 0, "k": 100 } }
          ]
        },
        {
          "ind": 3,
          "ty": 4,
          "tt": 1,
          "parent": 2,
          "ks": {},
          "ip": 0,
          "op": 685,
          "st": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "p": { "a": 0, "k": [146.12, 76.75] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [881.52, 338.5] }
                },
                { "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
                { "ty": "tr", "o": { "a": 0, "k": 100 } }
              ]
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 0,
                        "s": [100, 100],
                        "i": { "x": [0.009, 1], "y": [0.983, 1] },
                        "o": { "x": [0.508, 0], "y": [0, 0] }
                      },
                      {
                        "t": 46.8,
                        "s": [54.01, 100],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 61.8,
                        "s": [133.198, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 106.8,
                        "s": [120, 100],
                        "i": { "x": [0, 1], "y": [1, 1] },
                        "o": { "x": [0.5, 0], "y": [0, 0] }
                      },
                      {
                        "t": 154.8,
                        "s": [54, 100],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 169.8,
                        "s": [133.2, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 214.8,
                        "s": [120, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 232.8,
                        "s": [133.2, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 268.8,
                        "s": [47.4, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 304.8,
                        "s": [54, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 322.8,
                        "s": [27.8, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 358.8,
                        "s": [198.1, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 394.8,
                        "s": [185, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 412.8,
                        "s": [211.2, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 448.8,
                        "s": [40.9, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 484.8,
                        "s": [54, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 502.8,
                        "s": [14.8, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 538.8,
                        "s": [269.6, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 574.8,
                        "s": [250, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 585.72,
                        "s": [277.44, 100],
                        "i": { "x": [0.31, 1], "y": [1, 1] },
                        "o": { "x": [0.42, 0], "y": [0, 0] }
                      },
                      {
                        "t": 613.32,
                        "s": [40.28, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 634.8,
                        "s": [54, 100],
                        "i": { "x": [1, 0.65], "y": [1, 1] },
                        "o": { "x": [0, 0.35], "y": [0, 0] }
                      },
                      {
                        "t": 643.536,
                        "s": [54, 107],
                        "i": { "x": [1, 0.31], "y": [1, 1] },
                        "o": { "x": [0, 0.42], "y": [0, 0] }
                      },
                      {
                        "t": 665.616,
                        "s": [54, 46.5],
                        "i": { "x": [1, 0.4], "y": [1, 1] },
                        "o": { "x": [0, 0.25], "y": [0, 0] }
                      },
                      {
                        "t": 682.8,
                        "s": [54, 50],
                        "i": { "x": [1, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      { "t": 684, "s": [54, 50], "h": 1 }
                    ]
                  },
                  "r": { "a": 0, "k": 320 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "t": 0,
                        "s": [200, 200],
                        "i": { "x": [0.009, 1], "y": [0.983, 1] },
                        "o": { "x": [0.508, 0], "y": [0, 0] }
                      },
                      {
                        "t": 46.8,
                        "s": [108.02, 200],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 61.8,
                        "s": [266.396, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 106.8,
                        "s": [240, 200],
                        "i": { "x": [0, 1], "y": [1, 1] },
                        "o": { "x": [0.5, 0], "y": [0, 0] }
                      },
                      {
                        "t": 154.8,
                        "s": [108, 200],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 169.8,
                        "s": [266.4, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 214.8,
                        "s": [240, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 232.8,
                        "s": [266.4, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 268.8,
                        "s": [94.8, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 304.8,
                        "s": [108, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 322.8,
                        "s": [55.6, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 358.8,
                        "s": [396.2, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 394.8,
                        "s": [370, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 412.8,
                        "s": [422.4, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 448.8,
                        "s": [81.8, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 484.8,
                        "s": [108, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 502.8,
                        "s": [29.6, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 538.8,
                        "s": [539.2, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 574.8,
                        "s": [500, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 585.72,
                        "s": [554.88, 200],
                        "i": { "x": [0.31, 1], "y": [1, 1] },
                        "o": { "x": [0.42, 0], "y": [0, 0] }
                      },
                      {
                        "t": 613.32,
                        "s": [80.56, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 634.8,
                        "s": [108, 200],
                        "i": { "x": [1, 0.65], "y": [1, 1] },
                        "o": { "x": [0, 0.35], "y": [0, 0] }
                      },
                      {
                        "t": 643.536,
                        "s": [108, 214],
                        "i": { "x": [1, 0.31], "y": [1, 1] },
                        "o": { "x": [0, 0.42], "y": [0, 0] }
                      },
                      {
                        "t": 665.616,
                        "s": [108, 93],
                        "i": { "x": [1, 0.4], "y": [1, 1] },
                        "o": { "x": [0, 0.25], "y": [0, 0] }
                      },
                      {
                        "t": 682.8,
                        "s": [108, 100],
                        "i": { "x": [1, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      { "t": 684, "s": [108, 100], "h": 1 }
                    ]
                  }
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1] },
                  "lc": 1,
                  "lj": 1,
                  "ml": 10,
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 64 }
                },
                { "ty": "tr", "o": { "a": 0, "k": 100 } }
              ]
            }
          ]
        },
        {
          "ind": 2,
          "ty": 3,
          "ks": { "p": { "a": 0, "k": [263, 61] } },
          "ip": 0,
          "op": 685,
          "st": 0
        }
      ]
    },
    {
      "id": "11",
      "layers": [
        {
          "ind": 10,
          "ty": 4,
          "td": 1,
          "parent": 8,
          "ks": {},
          "ip": 0,
          "op": 685,
          "st": 0,
          "shapes": [
            {
              "ty": "rc",
              "p": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [100, 100],
                    "i": { "x": [0.009, 1], "y": [0.983, 1] },
                    "o": { "x": [0.508, 0], "y": [0, 0] }
                  },
                  {
                    "t": 46.8,
                    "s": [54.01, 100],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 61.8,
                    "s": [133.198, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 106.8,
                    "s": [120, 100],
                    "i": { "x": [0, 1], "y": [1, 1] },
                    "o": { "x": [0.5, 0], "y": [0, 0] }
                  },
                  {
                    "t": 154.8,
                    "s": [54, 100],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 169.8,
                    "s": [133.2, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 214.8,
                    "s": [120, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 232.8,
                    "s": [107, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 268.8,
                    "s": [191.5, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 304.8,
                    "s": [185, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 322.8,
                    "s": [198, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 358.8,
                    "s": [113.5, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 394.8,
                    "s": [120, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 412.8,
                    "s": [133.2, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 448.8,
                    "s": [47.4, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 484.8,
                    "s": [54, 100],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 634.8,
                    "s": [54, 100],
                    "i": { "x": [1, 0.65], "y": [1, 1] },
                    "o": { "x": [0, 0.35], "y": [0, 0] }
                  },
                  {
                    "t": 644.4,
                    "s": [54, 110],
                    "i": { "x": [1, 0.25], "y": [1, 1] },
                    "o": { "x": [0, 0.45], "y": [0, 0] }
                  },
                  {
                    "t": 663.6,
                    "s": [54, 45],
                    "i": { "x": [1, 0.4], "y": [1, 1] },
                    "o": { "x": [0, 0.25], "y": [0, 0] }
                  },
                  {
                    "t": 682.8,
                    "s": [54, 50],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  { "t": 684, "s": [54, 50], "h": 1 }
                ]
              },
              "r": { "a": 0, "k": 320 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [200, 200],
                    "i": { "x": [0.009, 1], "y": [0.983, 1] },
                    "o": { "x": [0.508, 0], "y": [0, 0] }
                  },
                  {
                    "t": 46.8,
                    "s": [108.02, 200],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 61.8,
                    "s": [266.396, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 106.8,
                    "s": [240, 200],
                    "i": { "x": [0, 1], "y": [1, 1] },
                    "o": { "x": [0.5, 0], "y": [0, 0] }
                  },
                  {
                    "t": 154.8,
                    "s": [108, 200],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 169.8,
                    "s": [266.4, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 214.8,
                    "s": [240, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 232.8,
                    "s": [214, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 268.8,
                    "s": [383, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 304.8,
                    "s": [370, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 322.8,
                    "s": [396, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 358.8,
                    "s": [227, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 394.8,
                    "s": [240, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 412.8,
                    "s": [266.4, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 448.8,
                    "s": [94.8, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 484.8,
                    "s": [108, 200],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 634.8,
                    "s": [108, 200],
                    "i": { "x": [1, 0.65], "y": [1, 1] },
                    "o": { "x": [0, 0.35], "y": [0, 0] }
                  },
                  {
                    "t": 644.4,
                    "s": [108, 220],
                    "i": { "x": [1, 0.25], "y": [1, 1] },
                    "o": { "x": [0, 0.45], "y": [0, 0] }
                  },
                  {
                    "t": 663.6,
                    "s": [108, 90],
                    "i": { "x": [1, 0.4], "y": [1, 1] },
                    "o": { "x": [0, 0.25], "y": [0, 0] }
                  },
                  {
                    "t": 682.8,
                    "s": [108, 100],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  { "t": 684, "s": [108, 100], "h": 1 }
                ]
              }
            },
            { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1] }, "o": { "a": 0, "k": 100 } }
          ]
        },
        {
          "ind": 9,
          "ty": 4,
          "tt": 1,
          "parent": 8,
          "ks": {},
          "ip": 0,
          "op": 685,
          "st": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "p": { "a": 0, "k": [122.7, 77.5] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [610.6, 349] }
                },
                { "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
                { "ty": "tr", "o": { "a": 0, "k": 100 } }
              ]
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 0,
                        "s": [100, 100],
                        "i": { "x": [0.009, 1], "y": [0.983, 1] },
                        "o": { "x": [0.508, 0], "y": [0, 0] }
                      },
                      {
                        "t": 46.8,
                        "s": [54.01, 100],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 61.8,
                        "s": [133.198, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 106.8,
                        "s": [120, 100],
                        "i": { "x": [0, 1], "y": [1, 1] },
                        "o": { "x": [0.5, 0], "y": [0, 0] }
                      },
                      {
                        "t": 154.8,
                        "s": [54, 100],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 169.8,
                        "s": [133.2, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 214.8,
                        "s": [120, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 232.8,
                        "s": [107, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 268.8,
                        "s": [191.5, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 304.8,
                        "s": [185, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 322.8,
                        "s": [198, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 358.8,
                        "s": [113.5, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 394.8,
                        "s": [120, 100],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 412.8,
                        "s": [133.2, 100],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 448.8,
                        "s": [47.4, 100],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 484.8,
                        "s": [54, 100],
                        "i": { "x": [1, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 634.8,
                        "s": [54, 100],
                        "i": { "x": [1, 0.65], "y": [1, 1] },
                        "o": { "x": [0, 0.35], "y": [0, 0] }
                      },
                      {
                        "t": 644.4,
                        "s": [54, 110],
                        "i": { "x": [1, 0.25], "y": [1, 1] },
                        "o": { "x": [0, 0.45], "y": [0, 0] }
                      },
                      {
                        "t": 663.6,
                        "s": [54, 45],
                        "i": { "x": [1, 0.4], "y": [1, 1] },
                        "o": { "x": [0, 0.25], "y": [0, 0] }
                      },
                      {
                        "t": 682.8,
                        "s": [54, 50],
                        "i": { "x": [1, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      { "t": 684, "s": [54, 50], "h": 1 }
                    ]
                  },
                  "r": { "a": 0, "k": 320 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "t": 0,
                        "s": [200, 200],
                        "i": { "x": [0.009, 1], "y": [0.983, 1] },
                        "o": { "x": [0.508, 0], "y": [0, 0] }
                      },
                      {
                        "t": 46.8,
                        "s": [108.02, 200],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 61.8,
                        "s": [266.396, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 106.8,
                        "s": [240, 200],
                        "i": { "x": [0, 1], "y": [1, 1] },
                        "o": { "x": [0.5, 0], "y": [0, 0] }
                      },
                      {
                        "t": 154.8,
                        "s": [108, 200],
                        "i": { "x": [0.2, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 169.8,
                        "s": [266.4, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.2, 0], "y": [0, 0] }
                      },
                      {
                        "t": 214.8,
                        "s": [240, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 232.8,
                        "s": [214, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 268.8,
                        "s": [383, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 304.8,
                        "s": [370, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 322.8,
                        "s": [396, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 358.8,
                        "s": [227, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 394.8,
                        "s": [240, 200],
                        "i": { "x": [0.65, 1], "y": [1, 1] },
                        "o": { "x": [0.35, 0], "y": [0, 0] }
                      },
                      {
                        "t": 412.8,
                        "s": [266.4, 200],
                        "i": { "x": [0.25, 1], "y": [1, 1] },
                        "o": { "x": [0.45, 0], "y": [0, 0] }
                      },
                      {
                        "t": 448.8,
                        "s": [94.8, 200],
                        "i": { "x": [0.4, 1], "y": [1, 1] },
                        "o": { "x": [0.25, 0], "y": [0, 0] }
                      },
                      {
                        "t": 484.8,
                        "s": [108, 200],
                        "i": { "x": [1, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      {
                        "t": 634.8,
                        "s": [108, 200],
                        "i": { "x": [1, 0.65], "y": [1, 1] },
                        "o": { "x": [0, 0.35], "y": [0, 0] }
                      },
                      {
                        "t": 644.4,
                        "s": [108, 220],
                        "i": { "x": [1, 0.25], "y": [1, 1] },
                        "o": { "x": [0, 0.45], "y": [0, 0] }
                      },
                      {
                        "t": 663.6,
                        "s": [108, 90],
                        "i": { "x": [1, 0.4], "y": [1, 1] },
                        "o": { "x": [0, 0.25], "y": [0, 0] }
                      },
                      {
                        "t": 682.8,
                        "s": [108, 100],
                        "i": { "x": [1, 1], "y": [1, 1] },
                        "o": { "x": [0, 0], "y": [0, 0] }
                      },
                      { "t": 684, "s": [108, 100], "h": 1 }
                    ]
                  }
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1] },
                  "lc": 1,
                  "lj": 1,
                  "ml": 10,
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 64 }
                },
                { "ty": "tr", "o": { "a": 0, "k": 100 } }
              ]
            }
          ]
        },
        {
          "ind": 8,
          "ty": 3,
          "ks": { "p": { "a": 0, "k": [151, 65] } },
          "ip": 0,
          "op": 685,
          "st": 0
        }
      ]
    }
  ],
  "fr": 60,
  "h": 200,
  "ip": 0,
  "layers": [
    {
      "ind": 7,
      "ty": 0,
      "parent": 1,
      "ks": {
        "a": { "a": 0, "k": [263, 61] },
        "o": {
          "a": 1,
          "k": [
            { "t": 0, "s": [100], "h": 1 },
            { "t": 634.8, "s": [100], "i": { "x": 0.75, "y": 1 }, "o": { "x": 0.35, "y": 0 } },
            { "t": 645.6, "s": [120], "i": { "x": 0.2, "y": 1 }, "o": { "x": 0.25, "y": 0 } },
            { "t": 670.8, "s": [0], "h": 1 },
            { "t": 684, "s": [0], "h": 1 }
          ]
        },
        "p": {
          "a": 1,
          "k": [
            {
              "t": 0,
              "s": [0, 0],
              "i": { "x": [0.009, 1], "y": [0.983, 1] },
              "o": { "x": [0.508, 0], "y": [0, 0] }
            },
            {
              "t": 46.8,
              "s": [0, 0],
              "i": { "x": [0, 1], "y": [1, 1] },
              "o": { "x": [0.501, 0], "y": [0, 0] }
            },
            {
              "t": 60,
              "s": [280, 0],
              "i": { "x": [0.271, 1], "y": [0.683, 1] },
              "o": { "x": [0.585, 0], "y": [0, 0] }
            },
            {
              "t": 83.4,
              "s": [262.729, 0],
              "i": { "x": [0.536, 1], "y": [1, 1] },
              "o": { "x": [0.22, 0], "y": [0.606, 0] }
            },
            {
              "t": 106.8,
              "s": [260, 0],
              "i": { "x": [0, 1], "y": [1, 1] },
              "o": { "x": [0.5, 0], "y": [0, 0] }
            },
            {
              "t": 154.8,
              "s": [260, 0],
              "i": { "x": [0, 1], "y": [1, 1] },
              "o": { "x": [0.501, 0], "y": [0, 0] }
            },
            {
              "t": 168,
              "s": [540, 0],
              "i": { "x": [0.271, 1], "y": [0.683, 1] },
              "o": { "x": [0.585, 0], "y": [0, 0] }
            },
            {
              "t": 191.4,
              "s": [522.729, 0],
              "i": { "x": [0.536, 1], "y": [1, 1] },
              "o": { "x": [0.22, 0], "y": [0.606, 0] }
            },
            {
              "t": 214.8,
              "s": [520, 0],
              "i": { "x": [0.65, 1], "y": [1, 1] },
              "o": { "x": [0.35, 0], "y": [0, 0] }
            },
            {
              "t": 232.8,
              "s": [493.6, 0],
              "i": { "x": [0.25, 1], "y": [1, 1] },
              "o": { "x": [0.45, 0], "y": [0, 0] }
            },
            {
              "t": 268.8,
              "s": [665.2, 0],
              "i": { "x": [0.4, 1], "y": [1, 1] },
              "o": { "x": [0.25, 0], "y": [0, 0] }
            },
            {
              "t": 304.8,
              "s": [652, 0],
              "i": { "x": [0.65, 1], "y": [1, 1] },
              "o": { "x": [0.35, 0], "y": [0, 0] }
            },
            {
              "t": 322.8,
              "s": [704.4, 0],
              "i": { "x": [0.25, 1], "y": [1, 1] },
              "o": { "x": [0.45, 0], "y": [0, 0] }
            },
            {
              "t": 358.8,
              "s": [363.8, 0],
              "i": { "x": [0.4, 1], "y": [1, 1] },
              "o": { "x": [0.25, 0], "y": [0, 0] }
            },
            {
              "t": 394.8,
              "s": [390, 0],
              "i": { "x": [0.65, 1], "y": [1, 1] },
              "o": { "x": [0.35, 0], "y": [0, 0] }
            },
            {
              "t": 412.8,
              "s": [337.6, 0],
              "i": { "x": [0.25, 1], "y": [1, 1] },
              "o": { "x": [0.45, 0], "y": [0, 0] }
            },
            {
              "t": 448.8,
              "s": [678.2, 0],
              "i": { "x": [0.4, 1], "y": [1, 1] },
              "o": { "x": [0.25, 0], "y": [0, 0] }
            },
            {
              "t": 484.8,
              "s": [652, 0],
              "i": { "x": [0.65, 1], "y": [1, 1] },
              "o": { "x": [0.35, 0], "y": [0, 0] }
            },
            {
              "t": 502.8,
              "s": [730.4, 0],
              "i": { "x": [0.25, 1], "y": [1, 1] },
              "o": { "x": [0.45, 0], "y": [0, 0] }
            },
            {
              "t": 538.8,
              "s": [220.8, 0],
              "i": { "x": [0.4, 1], "y": [1, 1] },
              "o": { "x": [0.25, 0], "y": [0, 0] }
            },
            {
              "t": 574.8,
              "s": [260, 0],
              "i": { "x": [1, 1], "y": [1, 1] },
              "o": { "x": [0, 0], "y": [0, 0] }
            },
            { "t": 684, "s": [260, 0], "h": 1 }
          ]
        }
      },
      "w": 818,
      "h": 275,
      "ip": 0,
      "op": 685,
      "st": 0,
      "refId": "5"
    },
    {
      "ind": 13,
      "ty": 0,
      "parent": 1,
      "ks": {
        "a": { "a": 0, "k": [151, 65] },
        "o": {
          "a": 1,
          "k": [
            { "t": 0, "s": [100], "h": 1 },
            { "t": 634.8, "s": [100], "i": { "x": 0.75, "y": 1 }, "o": { "x": 0.35, "y": 0 } },
            { "t": 645.6, "s": [120], "i": { "x": 0.2, "y": 1 }, "o": { "x": 0.25, "y": 0 } },
            { "t": 670.8, "s": [0], "h": 1 },
            { "t": 684, "s": [0], "h": 1 }
          ]
        },
        "p": {
          "a": 1,
          "k": [
            {
              "t": 0,
              "s": [0, 0],
              "i": { "x": [0.009, 1], "y": [0.983, 1] },
              "o": { "x": [0.508, 0], "y": [0, 0] }
            },
            {
              "t": 46.8,
              "s": [0, 0],
              "i": { "x": [0, 1], "y": [1, 1] },
              "o": { "x": [0.501, 0], "y": [0, 0] }
            },
            {
              "t": 60,
              "s": [280, 0],
              "i": { "x": [0.271, 1], "y": [0.683, 1] },
              "o": { "x": [0.585, 0], "y": [0, 0] }
            },
            {
              "t": 83.4,
              "s": [262.729, 0],
              "i": { "x": [0.536, 1], "y": [1, 1] },
              "o": { "x": [0.22, 0], "y": [0.606, 0] }
            },
            {
              "t": 106.8,
              "s": [260, 0],
              "i": { "x": [1, 1], "y": [1, 1] },
              "o": { "x": [0, 0], "y": [0, 0] }
            },
            {
              "t": 304.8,
              "s": [260, 0],
              "i": { "x": [0.648, 1], "y": [0.999, 1] },
              "o": { "x": [0.352, 0], "y": [0.001, 0] }
            },
            {
              "t": 322.8,
              "s": [286, 0],
              "i": { "x": [0.25, 1], "y": [1, 1] },
              "o": { "x": [0.451, 0], "y": [0.001, 0] }
            },
            {
              "t": 358.8,
              "s": [117, 0],
              "i": { "x": [0.399, 1], "y": [1, 1] },
              "o": { "x": [0.251, 0], "y": [0.001, 0] }
            },
            {
              "t": 394.8,
              "s": [130, 0],
              "i": { "x": [0.648, 1], "y": [0.999, 1] },
              "o": { "x": [0.352, 0], "y": [0.001, 0] }
            },
            {
              "t": 412.8,
              "s": [51.6, 0],
              "i": { "x": [0.25, 1], "y": [1, 1] },
              "o": { "x": [0.451, 0], "y": [0.001, 0] }
            },
            {
              "t": 448.8,
              "s": [561.2, 0],
              "i": { "x": [0.399, 1], "y": [1, 1] },
              "o": { "x": [0.251, 0], "y": [0.001, 0] }
            },
            {
              "t": 484.8,
              "s": [522, 0],
              "i": { "x": [0.65, 1], "y": [1, 1] },
              "o": { "x": [0.35, 0], "y": [0, 0] }
            },
            {
              "t": 502.8,
              "s": [600, 0],
              "i": { "x": [0.25, 1], "y": [1, 1] },
              "o": { "x": [0.45, 0], "y": [0, 0] }
            },
            {
              "t": 538.8,
              "s": [93, 0],
              "i": { "x": [0.4, 1], "y": [1, 1] },
              "o": { "x": [0.25, 0], "y": [0, 0] }
            },
            {
              "t": 574.8,
              "s": [132, 0],
              "i": { "x": [1, 1], "y": [1, 1] },
              "o": { "x": [0, 0], "y": [0, 0] }
            },
            {
              "t": 634.8,
              "s": [132, 0],
              "i": { "x": [1, 0.65], "y": [1, 1] },
              "o": { "x": [0, 0.35], "y": [0, 0] }
            },
            {
              "t": 644.4,
              "s": [132, -20],
              "i": { "x": [1, 0.25], "y": [1, 1] },
              "o": { "x": [0, 0.45], "y": [0, 0] }
            },
            {
              "t": 663.6,
              "s": [132, 110],
              "i": { "x": [1, 0.4], "y": [1, 1] },
              "o": { "x": [0, 0.25], "y": [0, 0] }
            },
            {
              "t": 682.8,
              "s": [132, 100],
              "i": { "x": [1, 1], "y": [1, 1] },
              "o": { "x": [0, 0], "y": [0, 0] }
            },
            { "t": 684, "s": [132, 100], "h": 1 }
          ]
        }
      },
      "w": 547,
      "h": 285,
      "ip": 0,
      "op": 685,
      "st": 0,
      "refId": "11"
    },
    {
      "ind": 16,
      "ty": 4,
      "td": 1,
      "parent": 14,
      "ks": {},
      "ip": 0,
      "op": 685,
      "st": 0,
      "shapes": [
        {
          "ty": "rc",
          "p": {
            "a": 1,
            "k": [
              {
                "t": 0,
                "s": [100, 100],
                "i": { "x": [0.009, 1], "y": [0.983, 1] },
                "o": { "x": [0.508, 0], "y": [0, 0] }
              },
              {
                "t": 46.8,
                "s": [54.01, 100],
                "i": { "x": [0.2, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              {
                "t": 61.8,
                "s": [133.198, 100],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.2, 0], "y": [0, 0] }
              },
              {
                "t": 106.8,
                "s": [120, 100],
                "i": { "x": [1, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              {
                "t": 304.8,
                "s": [120, 100],
                "i": { "x": [0.65, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 322.8,
                "s": [133.2, 100],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.45, 0], "y": [0, 0] }
              },
              {
                "t": 358.8,
                "s": [47.4, 100],
                "i": { "x": [0.4, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 394.8,
                "s": [54, 100],
                "i": { "x": [0.65, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 412.8,
                "s": [14.8, 100],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.45, 0], "y": [0, 0] }
              },
              {
                "t": 448.8,
                "s": [269.6, 100],
                "i": { "x": [0.4, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 484.8,
                "s": [250, 100],
                "i": { "x": [0.65, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 502.8,
                "s": [289.2, 100],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.45, 0], "y": [0, 0] }
              },
              {
                "t": 538.8,
                "s": [34.4, 100],
                "i": { "x": [0.4, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 574.8,
                "s": [54, 100],
                "i": { "x": [1, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              {
                "t": 648,
                "s": [54, 100],
                "i": { "x": [0.75, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 658.44,
                "s": [44.8, 100],
                "i": { "x": [0.2, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 682.8,
                "s": [100, 100],
                "i": { "x": [1, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              { "t": 684, "s": [100, 100], "h": 1 }
            ]
          },
          "r": { "a": 0, "k": 320 },
          "s": {
            "a": 1,
            "k": [
              {
                "t": 0,
                "s": [200, 200],
                "i": { "x": [0.009, 1], "y": [0.983, 1] },
                "o": { "x": [0.508, 0], "y": [0, 0] }
              },
              {
                "t": 46.8,
                "s": [108.02, 200],
                "i": { "x": [0.2, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              {
                "t": 61.8,
                "s": [266.396, 200],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.2, 0], "y": [0, 0] }
              },
              {
                "t": 106.8,
                "s": [240, 200],
                "i": { "x": [1, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              {
                "t": 304.8,
                "s": [240, 200],
                "i": { "x": [0.65, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 322.8,
                "s": [266.4, 200],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.45, 0], "y": [0, 0] }
              },
              {
                "t": 358.8,
                "s": [94.8, 200],
                "i": { "x": [0.4, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 394.8,
                "s": [108, 200],
                "i": { "x": [0.65, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 412.8,
                "s": [29.6, 200],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.45, 0], "y": [0, 0] }
              },
              {
                "t": 448.8,
                "s": [539.2, 200],
                "i": { "x": [0.4, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 484.8,
                "s": [500, 200],
                "i": { "x": [0.65, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 502.8,
                "s": [578.4, 200],
                "i": { "x": [0.25, 1], "y": [1, 1] },
                "o": { "x": [0.45, 0], "y": [0, 0] }
              },
              {
                "t": 538.8,
                "s": [68.8, 200],
                "i": { "x": [0.4, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 574.8,
                "s": [108, 200],
                "i": { "x": [1, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              {
                "t": 648,
                "s": [108, 200],
                "i": { "x": [0.75, 1], "y": [1, 1] },
                "o": { "x": [0.35, 0], "y": [0, 0] }
              },
              {
                "t": 658.44,
                "s": [89.6, 200],
                "i": { "x": [0.2, 1], "y": [1, 1] },
                "o": { "x": [0.25, 0], "y": [0, 0] }
              },
              {
                "t": 682.8,
                "s": [200, 200],
                "i": { "x": [1, 1], "y": [1, 1] },
                "o": { "x": [0, 0], "y": [0, 0] }
              },
              { "t": 684, "s": [200, 200], "h": 1 }
            ]
          }
        },
        { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1] }, "o": { "a": 0, "k": 100 } }
      ]
    },
    {
      "ind": 15,
      "ty": 4,
      "tt": 1,
      "parent": 14,
      "ks": {},
      "ip": 0,
      "op": 685,
      "st": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "p": { "a": 0, "k": [152, 100] },
              "r": { "a": 0, "k": 0 },
              "s": { "a": 0, "k": [916.8, 264] }
            },
            { "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 0] }, "o": { "a": 0, "k": 0 } },
            { "ty": "tr", "o": { "a": 0, "k": 100 } }
          ]
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "p": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [100, 100],
                    "i": { "x": [0.009, 1], "y": [0.983, 1] },
                    "o": { "x": [0.508, 0], "y": [0, 0] }
                  },
                  {
                    "t": 46.8,
                    "s": [54.01, 100],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 61.8,
                    "s": [133.198, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 106.8,
                    "s": [120, 100],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 304.8,
                    "s": [120, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 322.8,
                    "s": [133.2, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 358.8,
                    "s": [47.4, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 394.8,
                    "s": [54, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 412.8,
                    "s": [14.8, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 448.8,
                    "s": [269.6, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 484.8,
                    "s": [250, 100],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 502.8,
                    "s": [289.2, 100],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 538.8,
                    "s": [34.4, 100],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 574.8,
                    "s": [54, 100],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 648,
                    "s": [54, 100],
                    "i": { "x": [0.75, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 658.44,
                    "s": [44.8, 100],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 682.8,
                    "s": [100, 100],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  { "t": 684, "s": [100, 100], "h": 1 }
                ]
              },
              "r": { "a": 0, "k": 320 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [200, 200],
                    "i": { "x": [0.009, 1], "y": [0.983, 1] },
                    "o": { "x": [0.508, 0], "y": [0, 0] }
                  },
                  {
                    "t": 46.8,
                    "s": [108.02, 200],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 61.8,
                    "s": [266.396, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.2, 0], "y": [0, 0] }
                  },
                  {
                    "t": 106.8,
                    "s": [240, 200],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 304.8,
                    "s": [240, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 322.8,
                    "s": [266.4, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 358.8,
                    "s": [94.8, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 394.8,
                    "s": [108, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 412.8,
                    "s": [29.6, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 448.8,
                    "s": [539.2, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 484.8,
                    "s": [500, 200],
                    "i": { "x": [0.65, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 502.8,
                    "s": [578.4, 200],
                    "i": { "x": [0.25, 1], "y": [1, 1] },
                    "o": { "x": [0.45, 0], "y": [0, 0] }
                  },
                  {
                    "t": 538.8,
                    "s": [68.8, 200],
                    "i": { "x": [0.4, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 574.8,
                    "s": [108, 200],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  {
                    "t": 648,
                    "s": [108, 200],
                    "i": { "x": [0.75, 1], "y": [1, 1] },
                    "o": { "x": [0.35, 0], "y": [0, 0] }
                  },
                  {
                    "t": 658.44,
                    "s": [89.6, 200],
                    "i": { "x": [0.2, 1], "y": [1, 1] },
                    "o": { "x": [0.25, 0], "y": [0, 0] }
                  },
                  {
                    "t": 682.8,
                    "s": [200, 200],
                    "i": { "x": [1, 1], "y": [1, 1] },
                    "o": { "x": [0, 0], "y": [0, 0] }
                  },
                  { "t": 684, "s": [200, 200], "h": 1 }
                ]
              }
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1] },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 64 }
            },
            { "ty": "tr", "o": { "a": 0, "k": 100 } }
          ]
        }
      ]
    },
    { "ind": 14, "ty": 3, "parent": 1, "ks": {}, "ip": 0, "op": 685, "st": 0 },
    { "ind": 1, "ty": 3, "parent": 0, "ks": {}, "ip": 0, "op": 685, "st": 0 },
    { "ind": 0, "ty": 3, "ks": {}, "ip": 0, "op": 685, "st": 0 }
  ],
  "meta": { "g": "https://jitter.video" },
  "op": 684,
  "v": "5.7.4",
  "w": 900
}
